export enum TestResultGradation {
  Average = 'average',
  Maximum = 'maximum',
  Minimum = 'minimum',
}
